export default "__VITE_ASSET__Bmp0lhIt__"